import { object, string } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { topic } from './shared/topic'
import { brandVoiceId, tone } from './shared/voiceTones'
import { seoWords } from './shared/seoWords'
import { audience } from './shared/audience'
import { Briefs } from 'almanac-ui/icons/blaze/32'
import { safify } from './utils/safify'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { includeImages } from './shared/includeImages'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { brandKitId } from './shared/brandKitId'
import { language } from './shared/language'
import { TextChannels } from '../../../constants'

const meta = {
  type: GenerationType.ContentBrief,
  steps: ['Context', 'Generate Brief'],
  icon: Briefs,
  title: TextChannels[GenerationType.ContentBrief].name,
  submitLabel: 'Generate Brief',
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183791/Home%20Card%20Previews/exf2xlede9p9ptiub6je.png',
}

const fields = {
  topic: topic.meta({ label: 'What is the topic of your brief?', generationType: meta.type }),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  source_material_ids: sourceMaterialIds,
  include_images: includeImages,
  tone,
  seo_words: seoWords,
  language,
  goal: string()
    .default('')
    .meta({
      label: 'Goal',
      placeholder: 'The ultimate objective of this piece',
      collapsible: true,
      snippets: true,
      autoFill: true,
    })
    .transform(safify),
  audience: audience.meta({ collapsible: true }),
}

export const ContentBriefSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const ContentBriefMultiStepSchema: MultiStepSchema<GenerationType.ContentBrief> = {
  steps: [
    ContentBriefSchema.omit(['include_images']).meta({
      title: 'Purpose & Goals',
      submitLabel: 'Select Images',
    }) as StepSchema,
    SelectImages.meta({ submitLabel: meta.submitLabel, type: GenerationType.ContentBrief }) as StepSchema,
  ],
  meta: {
    ...meta,
    type: GenerationType.ContentBrief,
    channel: GenerationType.ContentBrief,
  },
}
